/**
 * Подсказки пустого статуса — те, что Discord показывает в пузыре у своего
 * аватара и в поле окна статуса. Одна наугад: карточка выбирает её и отдаёт
 * окну, чтобы в поле стояла та же, что была в пузыре.
 */
const PROMPTS = [
  "Во что играете?",
  "Что вы сейчас слушаете?",
  "Что вы сейчас смотрите?",
  "На чём вы сейчас зацикливаетесь?",
  "Расскажите о своём последнем внезапном озарении",
  "Сегодня оказалось, что...",
  "Выразите своё непопулярное мнение!",
  "Какой эмодзи лучше всего описывает ваш день?",
  "Какой ваш самый бесполезный талант?",
  "Что вы читаете?",
  "Последняя песня, которая застряла у вас в голове?",
  "Какой эмодзи вы чаще всего используете в последнее время?",
  "Лучшее, что вы ели на этой неделе?",
  "В каком вымышленном мире вы бы хотели жить?",
  "Откуда у вас такое имя пользователя?",
  "Ваше последнее хобби?",
  "Не могу дождаться...",
  "О чём думаете?",
];

/** Без подсказки — как в Discord. */
export const DEFAULT_PROMPT = "О чём думаете?";

export function randomPrompt(): string {
  return PROMPTS[Math.floor(Math.random() * PROMPTS.length)];
}
